import type { Either } from '~/common/type-util/Either'
import type { IsObjectAndHasProperty } from '~/common/type-util/ObjectWithProperty'

/* Conditionally insert object props, usage:
    const obj = {
      ...insertPropsIf(true, {x:1}),
      {y:2},
    }
    ===>
    {x:1, y:2}
 */

export const insertPropsIf = <T extends {}>(condition: boolean, element: T): Either<T, {}> => (condition ? element : {})

export const objectHasOwnProperty = <T = Record<string, any>, U = any>(
  object: T | unknown,
  property: U
): object is IsObjectAndHasProperty<T, U> => !!object && Object.hasOwn(object, String(property))

export const objectEntries = <T extends object>(input: T) => Object.entries(input) as [keyof T, T[keyof T]][]

export const convertStringToObjectCollection = (
  input?: string,
  fieldSeparator = ';',
  keyValueSeparator = '=',
  sanitizer: (arg0: string) => string = (value) => value
): Record<string, string> =>
  (input || '')
    .split(fieldSeparator)
    .map((row) => {
      if (!row) {
        return {}
      }
      const [key = '', value] = row.split(keyValueSeparator)
      return {
        [sanitizer(key.trim())]: sanitizer(value),
      }
    })
    .reduce((container, item) => Object.assign({}, container, item))
